import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-e29552ae"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "产品信息", -1); });
var _hoisted_4 = { class: "submit-box" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("提交");
import { ref } from "vue";
import { Form, NavBar, Button, Toast, Icon, } from "vant";
import { departDoctor, queryExpressInfo, requestDoctorList } from "@/api";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DepartDoctor',
    setup: function (__props) {
        var _this = this;
        var _a, _b;
        var route = useRoute();
        var router = useRouter();
        var onLoadloading = ref(true);
        if (((_a = route.query) === null || _a === void 0 ? void 0 : _a.sendStatus) === "2") {
            queryExpressInfo((_b = route.query) === null || _b === void 0 ? void 0 : _b.orderId)
                .then(function (res) {
                console.log(res.data);
                address.value = res.data.senderAddress;
                sender.value = res.data.sender;
                senderPhone.value = res.data.senderPhone;
                // sendTime.value = [];
                // sendDate.value = [];
                dateLabel.value = res.data.sendTime.substring(0, res.data.sendTime.lastIndexOf(":"));
            })
                .catch(function () {
                onLoadloading.value = false;
                Toast("网络错误-08");
            });
        }
        var address = ref("");
        var sender = ref("");
        var senderPhone = ref("");
        var formRef = ref();
        var toTwoDigits = function (num) {
            return num < 10 ? "0" + num : num.toString();
        };
        var sendTime = ref([
            toTwoDigits(new Date().getHours() + 1),
            toTwoDigits(new Date().getMinutes()),
        ]);
        console.log(sendTime.value);
        var sendDate = ref([]);
        var dateLabel = ref();
        var datePickerVisible = ref(false);
        var handleDateSelect = function (date) {
            dateLabel.value =
                date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) +
                    "-" +
                    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
            datePickerVisible.value = false;
            timePickerVisible.value = true;
            sendDate.value = dateLabel.value;
        };
        var timePickerVisible = ref(false);
        var handleTimeSelect = function (_a) {
            var selectedValues = _a.selectedValues;
            dateLabel.value = dateLabel.value + " " + selectedValues.join(":");
            timePickerVisible.value = false;
            sendTime.value = selectedValues;
        };
        var loading = ref(false);
        var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                formRef.value.validate().then(function () { return __awaiter(_this, void 0, void 0, function () {
                    var res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                loading.value = true;
                                return [4 /*yield*/, departDoctor(route.query.orderId, departId.value, doctorId.value).catch(function () {
                                        Toast("网络错误-07");
                                        loading.value = false;
                                    })];
                            case 1:
                                res = _a.sent();
                                loading.value = false;
                                if (res.code === 200) {
                                    Toast("分配成功");
                                    router.replace("/salesman-my-orders");
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        var doctorCascaderVisible = ref(false);
        var doctorLabel = ref("");
        var doctorOptions = ref([]);
        var getDoctorList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        2;
                        return [4 /*yield*/, requestDoctorList((_a = route.query) === null || _a === void 0 ? void 0 : _a.hospitalId)];
                    case 1:
                        res = _b.sent();
                        if (res.code === 200) {
                            doctorOptions.value = res.data.map(function (item) { return ({
                                text: item.departName,
                                value: item.departId,
                                children: item.doctorList.map(function (doctor) { return ({
                                    text: doctor.doctorName,
                                    value: doctor.doctorId,
                                }); }),
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var departId = ref(); // 科室id
        var doctorId = ref(); // 医生id
        var onFinish = function (_a) {
            var selectedOptions = _a.selectedOptions;
            doctorLabel.value = selectedOptions.map(function (option) { return option.text; }).join("/");
            departId.value = selectedOptions[0].value;
            doctorId.value = selectedOptions[1].value;
            doctorCascaderVisible.value = false;
        };
        return function (_ctx, _cache) {
            var _component_van_field = _resolveComponent("van-field");
            var _component_van_cascader = _resolveComponent("van-cascader");
            var _component_van_popup = _resolveComponent("van-popup");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "分配医生",
                    onClickLeft: _cache[0] || (_cache[0] =
                        function () {
                            _unref(router).go(-1);
                        })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Form), {
                        ref_key: "formRef",
                        ref: formRef
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_3,
                            _createVNode(_component_van_field, {
                                modelValue: doctorLabel.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((doctorLabel).value = $event); }),
                                name: "科室/医生",
                                label: "科室/医生",
                                "is-link": "",
                                readonly: "",
                                placeholder: "请选择您就诊医生",
                                onClick: _cache[2] || (_cache[2] =
                                    function () {
                                        doctorCascaderVisible.value = true;
                                        getDoctorList();
                                    }),
                                rules: [{ required: true, message: '请选择您就诊医生' }]
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_van_popup, {
                                show: doctorCascaderVisible.value,
                                "onUpdate:show": _cache[5] || (_cache[5] = function ($event) { return ((doctorCascaderVisible).value = $event); }),
                                round: "",
                                position: "bottom"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_van_cascader, {
                                        modelValue: _ctx.doctor,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_ctx.doctor) = $event); }),
                                        title: "请选择您就诊医生",
                                        options: doctorOptions.value,
                                        onClose: _cache[4] || (_cache[4] = function ($event) { return (doctorCascaderVisible.value = false); }),
                                        onFinish: onFinish
                                    }, null, 8, ["modelValue", "options"])
                                ]; }),
                                _: 1
                            }, 8, ["show"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_unref(Button), {
                                    color: "#3DABA4",
                                    size: "large",
                                    round: "",
                                    onClick: handleSubmit,
                                    loading: loading.value
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_5
                                    ]; }),
                                    _: 1
                                }, 8, ["loading"])
                            ])
                        ]; }),
                        _: 1
                    }, 512)
                ])
            ]));
        };
    }
});
